import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import connectToStores from '../../helpers/connectToStores';
import SmartcardStore from '../../stores/SmartcardStore';
import TocOnlyStore from '../../stores/TocOnlyStore';
import FeatureFlagStore from '../../stores/FeatureFlagStore';
import OrderStore from '../../stores/OrderStore';
import Search from '../../records/Search';
import User from '../../records/User';
import Smartcard from '../../records/customer/Smartcard';
import CustomerActions from '../../actions/CustomerActions';
import Order from '../../records/Order';

import DateTimeSummary from './dates/DateTimeSummary';
import JourneySelector from './JourneySelector';
import PassengersSummary from './PassengersSummary';
import SmartcardRailcard from '../smartcard/Railcard';
import SmartcardPassengerDetails from './../smartcard/PassengerDetails';
import TocSpecificSelector from './TocSpecificSelector';
import JourneyDetailsVerticalRenderer from './JourneyDetailsVerticalRenderer';
import PromoDiscount from './PromoDiscount';
import FeatureFlag from '../general/FeatureFlag';

function _getStateFromStores () {
    const enableSmartcardMaintenance = FeatureFlagStore.get('enableSmartcardMaintenance'),
        shouldGetSmartcard = SmartcardStore.shouldGetSmartcard(),
        smartcard = SmartcardStore.get('smartcard'),
        smartcardFailure = SmartcardStore.get('smartcardFailure') ? true : false,
        order = OrderStore.getCurrent();

    return {
        enableSmartcardMaintenance,
        shouldGetSmartcard,
        smartcard,
        smartcardFailure,
        order
    };
}

export class JourneyDetailsForm extends React.PureComponent {

    static propTypes = {
        search: PropTypes.instanceOf(Search).isRequired,
        user: PropTypes.instanceOf(User).isRequired,
        handleSearchChange: PropTypes.func,
        enableSmartcardMaintenance: PropTypes.bool.isRequired,
        shouldGetSmartcard: PropTypes.bool.isRequired,
        smartcardFailure: PropTypes.bool.isRequired,
        smartcard: PropTypes.instanceOf(Smartcard),
        enableStationFinder: PropTypes.bool,
        tocSpecificSelectorVisible: PropTypes.bool,
        hideSmartcardInfo: PropTypes.bool,
        order: PropTypes.instanceOf(Order),
        overlayStationResults: PropTypes.bool,
        renderer: PropTypes.func,
        searchAttempted: PropTypes.bool,
        hideRailcards: PropTypes.bool
    };

    static defaultProps = {
        order: null,
        smartcard: null,
        handleSearchChange: _.noop,
        enableStationFinder: false,
        tocSpecificSelectorVisible: false,
        overlayStationResults: false,
        renderer: JourneyDetailsVerticalRenderer,
        searchAttempted: false,
        hideRailcards: false,
    };

    state = {
        search: this.props.search
    };

    UNSAFE_componentWillReceiveProps (nextProps) {
        const { enableSmartcardMaintenance, smartcardFailure, user } = nextProps;
        let { search } = nextProps;
        if (!user.isLoggedIn() && enableSmartcardMaintenance || smartcardFailure) {
            search = search.set('smartcard', false);
        }

        this.setState({
            search,
        });
    }

    componentDidMount () {
        if (!this._smartcardDisabled()) {
            CustomerActions.getSmartcard(this.props.user);
        }
    }

    _smartcardDisabled () {
        return this.props.enableSmartcardMaintenance || !this.props.shouldGetSmartcard;
    }

    _handleChangeFor = (key) => {
        return (value) => {
            this.props.handleSearchChange(this.state.search.set(key, value));
        };
    };

    _handlePassengersChange = (adults, children, railcards) => {
        const search = this.state.search.set('adults', adults).set('children', children).set('railcards', railcards);
        this.props.handleSearchChange(search);
    };

    _isViewingSmartcardFares () {
        const { smartcard, search } = this.props;
        return smartcard && smartcard.canSearchForProducts() && search.smartcard;
    }

    _renderPassengersSummary () {
        const { search } = this.props;

        if (this._isViewingSmartcardFares()) {
            return (
                <SmartcardRailcard
                    search={ search }
                    onChange={ this._handleChangeFor('railcards') }/>
            );
        }

        return (
            <PassengersSummary
                railcards={ search.railcards }
                adults={ search.adults }
                children={ search.children }
                onChange={ this._handlePassengersChange }
                hideRailcards={ this.props.hideRailcards }
                hideFareInfo={ this.props.hideFareInfo}
            />
        );
    }

    _renderSmartcardDetails () {
        return !this._smartcardDisabled() && this._isViewingSmartcardFares() && (
            <SmartcardPassengerDetails smartcard={ this.props.smartcard }/>
        );
    }

    _renderPromoDiscount () {
        return (
            <FeatureFlag name='enablePromoDiscount'>
                <PromoDiscount promoCode={this.props.search.promoCode} onChange={ this._handleChangeFor('promoCode') } order={this.props.order} />
            </FeatureFlag>
        );
    }

    render () {
        const {
                smartcard,
                enableStationFinder,
                tocSpecificSelectorVisible,
                handleSearchChange,
                overlayStationResults,
                renderer: FormRenderer
                } = this.props,
            { search } = this.state,
            isAwaitingProduct = _.result(smartcard, 'isAwaitingProduct');
            const showTocSpecificSelector = search.origin.id && search.destination.id && tocSpecificSelectorVisible;

        const { searchAttempted } = this.props;

        return (<FormRenderer
                    journeySelector={ (
                        <JourneySelector
                            searchErrors={ search.getValidationErrors() }
                            search={ search }
                            searchAttempted={ searchAttempted }
                            enableStationFinder={ enableStationFinder }
                            onChange={ handleSearchChange }
                            overlayResults={ overlayStationResults }
                        />) }
                    tocSpecificSelector={ showTocSpecificSelector && (
                        <TocSpecificSelector
                            search={ search }
                            onChange={ handleSearchChange }/>
                        ) }
                    dateTimePicker={ (
                        <DateTimeSummary
                            searchErrors={ search.getValidationErrors() }
                            search={ search }
                            smartcard={ smartcard }
                            onChange={ handleSearchChange }
                            disableTodayTomorrow={ isAwaitingProduct }/> ) }
                    passengers={ this._renderPassengersSummary() }
                    smartcardDetails={ this._renderSmartcardDetails() }
                    promoDiscount={ this._renderPromoDiscount() }
                />);
    }
}

export default connectToStores([FeatureFlagStore, SmartcardStore, TocOnlyStore, OrderStore], _getStateFromStores)(JourneyDetailsForm);



// WEBPACK FOOTER //
// ./src/components/search/JourneyDetailsForm.js